import React from 'react';
import { FaSmile } from 'react-icons/fa';
import '../Why/Why.css';

const Why = () => {
  return (
    <section className="why-section">
      <div className="why-container">
        <div className="why-content">
          <h2><span>Why</span> Choose Us?</h2>
          <p className="subtitle">Let us make your celebration truly unforgettable with passion, creativity, and care.</p>
          <div className="why-points">
            {[
              {
                title: "Friendly Team",
                desc: "Our professional and approachable team ensures every event feels personal and perfect."
              },
              {
                title: "Perfect Venues",
                desc: "We offer stunning and flexible venues that suit every theme and occasion beautifully."
              },
              {
                title: "Unique Scenarios",
                desc: "From décor to lighting, we craft one-of-a-kind experiences tailored just for you."
              },
              {
                title: "Creative Planning",
                desc: "We turn ideas into reality with flair, precision, and a touch of magic."
              }
            ].map((point, index) => (
              <div className="point" key={index}>
                <div className="icon"><FaSmile /></div>
                <div>
                  <h3>{point.title}</h3>
                  <p>{point.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why;
